import { useContext } from "react";
import { store } from "../../store";

const usePermission = () => {
  const { permissions, setPermissions } = useContext(store);

  return { permissions, setPermissions };
};

export default usePermission;
